export default __webpack_public_path__ + "static/media/logo.ad815574.svg";